/* eslint-disable import/prefer-default-export */

import { LOT_ORDER_LIMIT, ORDER_TYPE } from 'constants/trading';
import { getTargetAPI } from 'features/securities/utils';
import { SplitOrderMethodEnum } from 'global/Securities/types/transaction';

export const getInitialPrice = (
  companyData,
  orderType,
  amendPreviousPrice?: number,
) => {
  const { price, orderbook } = companyData;
  const { bid, offer } = orderbook || {};
  const defaultPrice = Number(price) || 0;

  const isAmend = [ORDER_TYPE.AMEND_BUY, ORDER_TYPE.AMEND_SELL].includes(
    orderType,
  );
  if (isAmend) return amendPreviousPrice || defaultPrice;

  const bidPrice = Number(bid?.price);
  const offerPrice = Number(offer?.price);
  const isARB = Number.isNaN(bidPrice);
  const isARA = Number.isNaN(offerPrice);

  // Return orderbook price when autoreject or fallback to price field
  if (isARB) return offerPrice || defaultPrice;
  if (isARA) return bidPrice || defaultPrice;

  if (orderType === ORDER_TYPE.BUY && offerPrice) return offerPrice;
  if (orderType === ORDER_TYPE.SELL && bidPrice) return bidPrice;

  return defaultPrice;
};

export const getLotOrderLimit = () => LOT_ORDER_LIMIT[getTargetAPI()];

interface iSplitOrderPayload {
  splitOrderActive: boolean;
  splitQuantity: number;
  splitRangeMin: number;
  splitRangeMax: number;
  splitMethod: SplitOrderMethodEnum;
}

interface iSplitOrderReturn {
  split_order: {
    qty: number;
    min_lot?: number;
    max_lot?: number;
    method?: SplitOrderMethodEnum;
  };

}

export const getSplitOrderPayload = ({
  splitOrderActive,
  splitQuantity,
  splitRangeMin,
  splitRangeMax,
  splitMethod,
}: iSplitOrderPayload): iSplitOrderReturn | Record<string, never> => {
  if (!splitOrderActive) return {};
  const isRandom = splitMethod === SplitOrderMethodEnum.RANDOM;

  let splitOrder: iSplitOrderReturn['split_order'] = {
    qty: splitQuantity,
    method: splitMethod,
  };

  if (isRandom) {
    splitOrder = {
      ...splitOrder,
      min_lot: splitRangeMin,
      max_lot: splitRangeMax,
    };
  }

  return {
    split_order: splitOrder,
  };
};
